<template>
  <!-- Настройка отчета: само окно-->
  <div
    id="skills-man-detail-template-setting"
    class="template-setting-window"
    style="display: flex"
  >
    <div class="template-setting-window-header">
      <div class="template-setting-window-header-name">
        <strong>Навыки MAN (детализация)</strong><br />
        <small>Настройка отчета</small>
      </div>
      <div
        v-if="isAwaitingEndOption"
        class="template-setting-window-header-multi-status"
      >
        <small class="shift-hint-top"
          >Первая опция выбрана. Выберите конечную опцию для массового
          выделения</small
        >
      </div>
      <!-- Картинка крестика-->
      <img
        class="close"
        src="/images/close.png"
        @click="closeHandler"
      />
    </div>

    <div class="overflow-auto">
      <table class="unselectable">
        <tr>
          <td>
            <label for="skills-man-detail-template-poscount"
              >Число позиций</label
            >
          </td>
          <td>
            <input
              id="skills-man-detail-template-poscount"
              type="text"
              v-model="posCount"
            />
          </td>
        </tr>
        <tr>
          <td>
            <label for="skills-man-detail-template-allpositions"
              >Все позиции</label
            >
          </td>
          <td>
            <input
              id="skills-man-detail-template-allpositions"
              type="checkbox"
              v-model="allPositionsChecked"
            />
          </td>
        </tr>
      </table>
      <hr />

      <div
        id="skills-man-detail-template-violations"
        class="unselectable"
      >
        Нарушения
        <span
          data-elem="checked"
          class="padding-none margin-none btn btn-link"
          style="margin: 0"
          >Выбрать все</span
        >
        <span
          data-elem="unChecked"
          class="padding-none margin-none btn btn-link"
          style="margin: 0"
          >Очистить все</span
        >

        <table>
          <tr
            v-for="descObj in nonGroupedViolations"
            :key="descObj.id"
          >
            <td>
              <input
                :data-id="descObj.id"
                :data-group="descObj.group_num"
                :id="'skills-man-detail-template-violation-' + descObj.id"
                type="checkbox"
                checked
                @click="handleViolationCheckboxClick"
              />
            </td>
            <td>
              <label
                data-desc
                :for="'skills-man-detail-template-violation-' + descObj.id"
                >{{ descObj.description }}</label
              >
            </td>
          </tr>
          <tr
            v-for="descObj in groupedViolations"
            :key="descObj[0].id"
          >
            <td>
              <input
                :data-id="descObj[0].id"
                :data-group="descObj[0].group_num"
                :id="'skills-man-detail-template-violation-' + descObj[0].id"
                type="checkbox"
                checked
                @click="handleViolationCheckboxClick"
              />
            </td>
            <td>
              <label
                data-desc
                :for="'skills-man-detail-template-violation-' + descObj[0].id"
                >{{ descObj[0].description }}</label
              >
            </td>
          </tr>
        </table>
      </div>

      <hr />

      <div class="padding-top-5 text-center">
        <small>Окончание настройки отчета</small>
      </div>
    </div>
    <div class="text-center">
      <small
        class="shift-hint"
        :class="{ 'shift-hint-animated': isHintAnimated }"
        >Зажмите SHIFT для множественного выделения промежуточных опций</small
      >
      <span
        class="target-show"
        @mouseenter="addHoverOnTargetByParent($event)"
        @mouseleave="removeHoverOnTargetByParent($event)"
      >
        <input
          id="skills-man-detail-template-setting-window-get-template-button"
          class="btn btn-sm"
          :class="[
            {
              'btn-warning': isButtonWarning,
              'btn-primary config-btn-primary': !isButtonWarning,
            },
          ]"
          type="submit"
          value="Выполнить отчет"
          @click="renderReport"
        />
        <span class="target-show-span">{{ targetText }}</span>
      </span>
    </div>
  </div>
</template>

<script setup>
import { inject, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { SkillsManDetailTemplate } from '../../../Template/skills_man_template/skills_man_detail_template';
import { skillsManTemplate } from '../../../Template/skills_man_template/skills_man_template';
import {
  addHoverOnTargetByParent,
  removeHoverOnTargetByParent,
} from '../../helpers/targetsHelper';
import { callOurPositions } from '../../use/getElementPosition';

const userData = inject('userData');

const props = defineProps({
  userRole: {
    type: String,
    default: '',
  },
  violationsDescriptions: { type: Object, require: true },
  form_desc: { type: Object, require: true },
  isShowing: {
    type: Boolean,
    default: false,
  },
});

const nonGroupedViolations = ref([]);
const groupedViolations = ref({});

const emit = defineEmits(['close']);

const posCount = ref('5');
const allPositionsChecked = ref(false);
const isButtonWarning = ref(false);
const targetText = ref('Обсчет данных для получения отчета');

let rangeFromCheckbox = null;
let previewRows = [];
const isAwaitingEndOption = ref(false);
const isHintAnimated = ref(false);
let hintAnimationTimer = null;

const getViolationsCheckboxes = () => {
  const container = document.getElementById(
    'skills-man-detail-template-violations',
  );
  if (!container) return [];
  return Array.from(container.querySelectorAll('input[type="checkbox"]'));
};

const clearRangePreview = () => {
  previewRows.forEach((row) =>
    row.classList.remove(
      'range-preview',
      'range-preview-first',
      'range-preview-last',
      'range-preview-single',
    ),
  );
  previewRows = [];
};

const updateRangePreview = (event) => {
  if (!rangeFromCheckbox) return;
  clearRangePreview();

  const row = event.target.closest ? event.target.closest('tr') : null;
  const hoveredCheckbox = row
    ? row.querySelector('input[type="checkbox"]')
    : null;
  if (!hoveredCheckbox) return;

  const checkboxes = getViolationsCheckboxes();
  const fromIndex = checkboxes.indexOf(rangeFromCheckbox);
  const hoverIndex = checkboxes.indexOf(hoveredCheckbox);
  if (fromIndex === -1 || hoverIndex === -1) return;

  const [from, to] = [fromIndex, hoverIndex].sort((a, b) => a - b);
  for (let i = from; i <= to; i++) {
    const tr = checkboxes[i].closest('tr');
    if (!tr) continue;
    tr.classList.add('range-preview');
    if (from === to) tr.classList.add('range-preview-single');
    if (i === from) tr.classList.add('range-preview-first');
    if (i === to) tr.classList.add('range-preview-last');
    previewRows.push(tr);
  }
};

const startRangeSelection = (checkbox) => {
  rangeFromCheckbox = checkbox;
  isAwaitingEndOption.value = true;
  checkbox.closest('tr')?.classList.add('range-start');
  document.addEventListener('mousemove', updateRangePreview);
};

const endRangeSelection = () => {
  rangeFromCheckbox?.closest('tr')?.classList.remove('range-start');
  rangeFromCheckbox = null;
  isAwaitingEndOption.value = false;
  clearRangePreview();
  document.removeEventListener('mousemove', updateRangePreview);
};

const handleViolationCheckboxClick = (event) => {
  if (!event.shiftKey && rangeFromCheckbox === null) {
    // endRangeSelection();
    return;
  }

  if (rangeFromCheckbox === null) {
    startRangeSelection(event.target);
    return;
  }

  const checkboxes = getViolationsCheckboxes();
  const currentIndex = checkboxes.indexOf(event.target);
  const fromIndex = checkboxes.indexOf(rangeFromCheckbox);
  const [from, to] = [fromIndex, currentIndex].sort((a, b) => a - b);
  const state = rangeFromCheckbox.checked;

  for (let i = from; i <= to; i++) {
    checkboxes[i].checked = state;
  }

  endRangeSelection();
};

const globalObjectsList = inject('globalObjectsList');

watch(
  () => props.violationsDescriptions,
  () => {
    const result = {};
    for (const key in props.violationsDescriptions) {
      if (props.violationsDescriptions.hasOwnProperty(key)) {
        const item = props.violationsDescriptions[key];

        if (item.group_num == 0) {
          nonGroupedViolations.value.push(item);
          continue;
        }
        if (!result[item.group_num]) {
          result[item.group_num] = [];
        }
        result[item.group_num].push(item);
      }
    }
    groupedViolations.value = result;
  },
  { immediate: true },
);

watch(posCount, () => {
  allPositionsChecked.value = false;
});

const startHintAnimation = () => {
  if (hintAnimationTimer !== null) clearTimeout(hintAnimationTimer);
  isHintAnimated.value = true;
  hintAnimationTimer = setTimeout(() => {
    isHintAnimated.value = false;
    hintAnimationTimer = null;
  }, 5000);
};

const stopHintAnimation = () => {
  if (hintAnimationTimer !== null) {
    clearTimeout(hintAnimationTimer);
    hintAnimationTimer = null;
  }
  isHintAnimated.value = false;
};

watch(
  () => props.isShowing,
  (showing) => {
    if (showing) {
      startHintAnimation();
    } else {
      stopHintAnimation();
      endRangeSelection();
    }
  },
);

let skillsManDetailTemplate;
onMounted(() => {
  isButtonWarning.value = false;
  targetText.value = 'Обсчет данных для получения отчета';
  skillsManDetailTemplate = new SkillsManDetailTemplate(
    skillsManTemplate,
    lodashRenderHtml_helper,
    props.userRole,
    userData,
  );
});

const renderReport = (event) => {
  const visibleElements = objectsListFormColorAndTarget_helper(props.form_desc);

  isButtonWarning.value = false;
  targetText.value = 'Обсчет данных для получения отчета';

  const dataRequest = {
    objId: props.form_desc.objects[0],
    timeBegin: +props.form_desc.beginTime,
    timeEnd: +props.form_desc.endTime,
  };

  callOurPositions({
    obj: globalObjectsList[dataRequest.objId] || { id: dataRequest.objId },
    clickElem: visibleElements.button,
    targetElem: visibleElements.targetSpan,
    timeInterval: {
      timeBegin: +dataRequest.timeBegin,
      timeEnd: dataRequest.timeEnd,
    },
    isOnMap: false,
    isDistFilter: false,
    skillsManDetailTemplate,
    isWebSocket: event.altKey,
  });
  closeHandler();
};
const closeHandler = () => {
  endRangeSelection();
  document.getElementById('background-wrap').style.display = 'none';
  emit('close', 'skillsManDetailSettings');
};

onBeforeUnmount(() => {
  endRangeSelection();
  if (hintAnimationTimer !== null) {
    clearTimeout(hintAnimationTimer);
    hintAnimationTimer = null;
  }
});
</script>

<style>
#skills-man-detail-template-violations > span:first-child {
  margin-right: 3px !important;
}

.shift-hint {
  float: left;
  display: inline;
  position: absolute;
  left: 17px;
  bottom: 21px;
}

.shift-hint-animated {
  border-radius: 4px;
  background-image: linear-gradient(
    90deg,
    #e74c3c,
    #f39c12,
    #2ecc71,
    #3498db,
    #9b59b6,
    #e74c3c
  );
  background-size: 300% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  /* box-shadow: inset 0 0 0 100px rgba(255, 243, 205, 0.7); */
  animation: shift-hint-flow 1.5s linear infinite;
}

@keyframes shift-hint-flow {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 300% 50%;
  }
}

.shift-hint-top {
  position: absolute;
  top: 20px;
}

.template-setting-window-header-multi-status {
  margin-left: auto;
  align-self: center;
  color: #a94442;
}

#skills-man-detail-template-violations tr.range-start > td {
  border-top: 2px solid #337ab7;
  border-bottom: 2px solid #337ab7;
  background-color: rgba(51, 122, 183, 0.12);
}

#skills-man-detail-template-violations tr.range-start > td:first-child {
  border-left: 2px solid #337ab7;
}

#skills-man-detail-template-violations tr.range-start > td:last-child {
  border-right: 2px solid #337ab7;
}

#skills-man-detail-template-violations tr.range-preview > td {
  background-color: rgba(51, 122, 183, 0.18);
}

#skills-man-detail-template-violations tr.range-preview-first > td {
  border-top: 2px solid #337ab7;
}

#skills-man-detail-template-violations tr.range-preview-last > td {
  border-bottom: 2px solid #337ab7;
}

#skills-man-detail-template-violations tr.range-preview > td:first-child {
  border-left: 2px solid #337ab7;
}

#skills-man-detail-template-violations tr.range-preview > td:last-child {
  border-right: 2px solid #337ab7;
}

#skills-man-detail-template-violations tr.range-preview-single > td {
  border-top: 2px solid #337ab7;
  border-bottom: 2px solid #337ab7;
}
</style>
